import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mee-delete-folder',
  templateUrl: './delete-folder.component.html',
  styleUrls: ['./delete-folder.component.scss'],
})
export class DeleteFolderComponent {
  matDialogRef = inject<MatDialogRef<DeleteFolderComponent>>(MatDialogRef);
}
